import InvestorOnboardingBanner from './investor-onboarding-banner';

export default InvestorOnboardingBanner;
